var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.91 16.806a10 10 0 0 1 2.01-.712 9.386 9.386 0 0 1 3.682-.102q.785.135 1.58.407V7.443a8 8 0 0 0-1.557-.475 8.4 8.4 0 0 0-3.739.113 7.8 7.8 0 0 0-1.977.814zM12 19q-.318 0-.602-.08a2.6 2.6 0 0 1-.534-.214A7.5 7.5 0 0 0 9 17.926a7.7 7.7 0 0 0-2-.26q-.954 0-1.875.248-.92.25-1.761.701-.478.25-.92-.022A.87.87 0 0 1 2 17.8V6.9q0-.249.125-.475a.8.8 0 0 1 .375-.34 11.3 11.3 0 0 1 2.193-.802A9.4 9.4 0 0 1 7 5q1.319 0 2.58.34A9.8 9.8 0 0 1 12 6.356 9.8 9.8 0 0 1 17 5q1.182 0 2.307.283 1.124.282 2.193.803a.8.8 0 0 1 .375.339Q22 6.65 22 6.9V17.8q0 .52-.443.792-.444.27-.92.023a8.3 8.3 0 0 0-1.762-.702A7.2 7.2 0 0 0 17 17.666q-1.022 0-2 .26a7.5 7.5 0 0 0-1.864.78 2.6 2.6 0 0 1-.534.215Q12.317 19 12 19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookFill);
export default __webpack_public_path__ + "static/media/book_fill.7f6d00b4fe586d67f3b51c2730f7d805.svg";
export { ForwardRef as ReactComponent };